/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";
import { observer } from "mobx-react-lite";
import { usePaymentStore, useUserStore } from "../../stores/StoreContext";
import { BOOKING_FEES_SERVICE_ID } from "../../utils/data";
import { formatAmount } from "../../utils/utils";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import "./PaymentDescription.css";

type props = {};

export const PaymentDescription: React.FC<props> = observer(() => {
  const paymentStore = usePaymentStore();
  const userStore = useUserStore();
  // const bookingService = paymentStore.productServicesResponse.find(
  //   (p) => p.categoryId === BOOKING_FEES_SERVICE_ID
  // );

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-end",
          marginTop: 15,
        }}>
        <TCText
          style={{ fontWeight: 500, fontSize: 14, color: Colors.green }}
          value="Price for remaining players"
        />
        <div>
          <TCText
            style={{
              fontWeight: 500,
              fontSize: 10,
              color: Colors.green,
              textAlign: "end",
            }}
            value="Incl. Tax"
          />
          {paymentStore.isPlayerPricesListLoading ? (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <LoadingSpinner
                loading
                className="small-spinner-border custom-spinner-color"
              />
            </div>
          ) : (
            <TCText
              style={{
                fontWeight: 600,
                fontSize: 16,
                color: Colors.green,
                marginTop: -5,
              }}
              value={`${formatAmount(
                paymentStore.totalAmount -
                  (paymentStore.playerPricesMap.get(
                    Number(userStore.userModel?.userId)
                  )?.totalPrice ?? 0)
              )} USD`}
            />
          )}
        </div>
      </div>
    </div>
  );
});
